import { dataMember, required, typedArray } from 'santee-dcts';

export class DocumentFilterItem {

    @dataMember()
    @required({ nullable: true })
    public type: KeyValuePair;

    @dataMember()
    @required({ nullable: true })
    public protocol: KeyValuePair;

    @dataMember()
    @required({ nullable: true })
    public project: KeyValuePair;

    @dataMember()
    @required({ nullable: true })
    public site: KeyValuePair;

    @dataMember()
    @required({ nullable: true })
    public visit: KeyValuePair;

    @dataMember()
    @required({ nullable: true })
    public subject: KeyValuePair;

    @dataMember()
    @required({ nullable: true })
    public accessionNumber: KeyValuePair;

    @dataMember()
    @required({ nullable: true })
    public subcategory: KeyValuePair;
    
    @dataMember()
    @required({ nullable: true })
    public sponsor: KeyValuePair;

    @dataMember()
    @required({ nullable: true })
    public kitType: KeyValuePair;

    @dataMember()
    @required({ nullable: true })
    public description: KeyValuePair;

    @dataMember()
    @required({ nullable: true })
    public status: KeyValuePair;

    @dataMember()
    @required({ nullable: true })
    public documentType: KeyValuePair;
}

export class KeyValuePair {
    @dataMember()
    @required()
    public key: string;

    @dataMember()
    @required()
    public value: string; 

    @dataMember()
    public siteProject?: any;

    public toString() {
        return this.value;
    }
}

export class DocumentFilterItemReadModel {
    @dataMember()
    @required()
    @typedArray(DocumentFilterItem)
    public documentFilterItems: DocumentFilterItem[];
}